import { Conversation } from '@/features/conversational';
import { useConfigStore } from '../stores/ConfigStore';
import { useFormStore } from '../stores/FormStore';
import Page from './Page';
import CustomPage from './CustomPage';

export default function FormContent({ formHeaderHeight }) {
	const { formOffset, formIsCompleted, formIsOnOpenerPage, loading, postFeedbackError } =
		useFormStore();
	const { properties, pageMap } = useConfigStore();

	if (properties.conversational) {
		return (
			<Conversation
				formOffset={formOffset}
				formHeaderHeight={formHeaderHeight}
			/>
		);
	}

	if (formIsOnOpenerPage && !properties.conversational) {
		return <CustomPage isFirstPage />;
	}

	if (formIsCompleted && !loading && !postFeedbackError && !properties.conversational) {
		return <CustomPage isLastPage />;
	}

	return Object.keys(pageMap).map(pageNumberKey => (
		<Page pageNumber={Number(pageNumberKey)} />
	));
}
